import Vue from 'vue'
import VueRouter from 'vue-router'
import store from 'store/index'
import baseFilter from 'filters/base'
import router from './router'
import App from './App'
import axios from '../src/axios/http'

// import './styles/base.styl'
import './stylus/reset.styl'
// promise等全局工具解析器
import 'babel-polyfill'
// 淘宝移动端适配方案
import 'lib-flexible'
// 优化滚动条
import BScroll from 'better-scroll'
import MintUI from '../node_modules/mint-ui';
import 'mint-ui/lib/style.css'
Vue.prototype.$axios = axios;
Vue.use(VueRouter);
Vue.use(baseFilter);
Vue.use(MintUI)
Vue.prototype.$BScroll = BScroll

const app = new Vue({
	router,
	store,
	components: {
		App
	},
	template: '<app/>'
});

app.$mount('#app');


// WEBPACK FOOTER //
// ./src/main.js